import React from 'react';

/**
 * Friendly empty-state panel with an optional primary call-to-action.
 *
 * Use anywhere a list, table or card grid would otherwise render as
 * nothing — bills, invoices, trust accounts, payroll runs, etc.
 *
 *   <EmptyState
 *     title="No invoices yet"
 *     message="Once you generate an invoice it will appear here."
 *     actionLabel="Create invoice"
 *     onAction={() => setShowAddInvoiceForm(true)}
 *   />
 */
export default function EmptyState({
  icon = null,
  title = 'Nothing to show yet',
  message = '',
  actionLabel = null,
  onAction = null,
}) {
  return (
    <div
      role="region"
      aria-label={title}
      style={{
        textAlign: 'center',
        padding: '36px 20px',
        border: '1px dashed #d1d5db',
        borderRadius: 12,
        background: '#fafafa',
        color: '#374151',
      }}
    >
      {icon && (
        <div aria-hidden="true" style={{ marginBottom: 8, fontSize: 32, opacity: 0.7 }}>
          {icon}
        </div>
      )}
      <h3 style={{ margin: '0 0 6px', fontSize: 16, fontWeight: 600 }}>{title}</h3>
      {message && (
        <p style={{ margin: '0 0 12px', fontSize: 14, color: '#6b7280' }}>{message}</p>
      )}
      {actionLabel && typeof onAction === 'function' && (
        <button
          type="button"
          onClick={onAction}
          className="inline-flex items-center justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}
